import type { BoardSnapshot, Move, Square } from './types';
import { START_FEN } from './types';
import { createChessJsAdapter } from './chessJsAdapter';

/**
 * Chess rules boundary. UI and state talk only to this interface.
 */
export interface ChessAdapter {
  loadFen(fen: string): void;
  tryLoadFen(fen: string): boolean;
  fen(): string;
  snapshot(): BoardSnapshot;
  moves(from?: Square): Move[];
  move(move: { from: Square; to: Square; promotion?: Move['promotion'] }): Move | null;
  isCheck(): boolean;
  isCheckmate(): boolean;
  isDraw(): boolean;
  isGameOver(): boolean;
  reset(fen?: string): void;
}

/** Production adapter (chess.js). */
export function createAdapter(initialFen: string = START_FEN): ChessAdapter {
  return createChessJsAdapter(initialFen);
}

/** @deprecated use createAdapter */
export const createStubAdapter = createAdapter;
